import '@rainbow-me/rainbowkit/styles.css';
import { RainbowKitProvider, darkTheme, connectorsForWallets } from '@rainbow-me/rainbowkit';
import { createStorage, cookieStorage, createConfig, WagmiProvider } from 'wagmi';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import {
    ethereumForBridge,
    polygonForBridge,
    binanceForBridge,
    larissaChainRainbow,
    arbitrumForBridge,
    baseForBridge,
    optimismForBridge,
} from '@/configs/chain';
import React from "react";
import theme from "@/theme/theme";
import { metaMaskWallet, walletConnectWallet } from "@rainbow-me/rainbowkit/wallets";
import { Chain, http } from "viem";

const supportedChains: Chain[] = [
    larissaChainRainbow,
    ethereumForBridge,
    polygonForBridge,
    binanceForBridge,
    arbitrumForBridge,
    baseForBridge,
    optimismForBridge,
];

const connectors = connectorsForWallets([
    {
        groupName: 'Recommended',
        wallets: [metaMaskWallet, walletConnectWallet],
    },
], {
    appName: 'Larissa Portal',
    appDescription: 'Larissa Portal',
    appUrl: 'https://larissa.network',
    appIcon: '/images/logos/128x128.png',
    projectId: `${import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || ''}`,
});

const config = createConfig({
    connectors,
    chains: supportedChains as never,
    ssr: false,
    storage: createStorage({
        storage: cookieStorage,
    }),
    transports: supportedChains.reduce((obj, chain) => ({ ...obj, [chain.id]: http() }), {})
});

const queryClient = new QueryClient();

export function CustomProvider({ children }: { children: React.ReactNode }) {
    return (
        <WagmiProvider config={config}>
            <QueryClientProvider client={queryClient}>
                <RainbowKitProvider theme={darkTheme({
                    accentColor: theme.colors.primary.hex,
                    accentColorForeground: 'white',
                    borderRadius: 'medium',
                    fontStack: 'system',
                    overlayBlur: 'small',
                })}>
                    {children}
                </RainbowKitProvider>
            </QueryClientProvider>
        </WagmiProvider>
    );
}

